import { render, staticRenderFns } from "./game-list-filter.vue?vue&type=template&id=ad5183aa&"
import script from "./game-list-filter.vue?vue&type=script&lang=js&"
export * from "./game-list-filter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports